<template>
  <b-container fluid>
    <iq-card>
        <template v-slot:headerTitle>
            <h4 class="card-title">{{ $t('delivery_management.distribution_receipt') }} {{ $t('globalTrans.search')}}</h4>
        </template>
        <template v-slot:body>
            <b-row>
                <b-col xs="12" sm="12" md="6" lg="6" xl="6">
                    <b-form-group
                        class="row"
                        label-cols-sm="4"
                        label-for="application_id"
                    >
                    <template v-slot:label>
                        {{ $t('info_manage.application_id')}}
                    </template>
                    <b-form-input
                        id="name"
                        v-model="search.application_id"
                        @change="loadData"
                    ></b-form-input>
                    </b-form-group>
                </b-col>
                <b-col xs="12" sm="12" md="6" lg="6" xl="6">
                  <b-form-group
                    class="row"
                    label-cols-sm="4"
                    label-for="application_id"
                  >
                    <template v-slot:label>
                      {{ $t('delivery_management.receipt_no')}}
                    </template>
                    <b-form-input
                      id="name"
                      v-model="search.receipt_no"
                    ></b-form-input>
                  </b-form-group>
                </b-col>
            </b-row>
            <b-row>
                <b-col xs="12" sm="12" md="6" lg="6" xl="6">
                    <b-form-group
                        class="row"
                        label-cols-sm="4"
                        :label="$t('globalTrans.from_date')"
                        label-for="from_date"
                        >
                        <b-form-input
                        class="date-picker"
                        v-model="search.from_date"
                        :placeholder="$t('globalTrans.date')"
                        id="from_date"
                        >
                        </b-form-input>
                    </b-form-group>
                </b-col>
              <b-col xs="12" sm="12" md="6" lg="6" xl="6">
                <b-form-group
                  class="row"
                  label-cols-sm="4"
                  :label="$t('globalTrans.to_date')"
                  label-for="to_date"
                >
                  <b-form-input
                    class="date-picker"
                    v-model="search.to_date"
                    :placeholder="$t('globalTrans.date')"
                    id="to_date"
                  >
                  </b-form-input>
                </b-form-group>
              </b-col>
            </b-row>
            <b-button type="button" variant="primary" @click="searchData">{{ $t('globalTrans.search')}}</b-button>
      </template>
    </iq-card>
    <b-row>
      <b-col md="12">
        <iq-card>
          <template v-slot:headerTitle>
            <h4 class="card-title">{{ $t('delivery_management.distribution_receipt') + ' ' + $t('globalTrans.list')}}</h4>
          </template>
          <template v-slot:body>
            <b-overlay :show="loadingState">
              <b-row>
                <b-col md="12" class="table-responsive">
                  <b-table thead-class="bg-primary" bordered hover :items="items" :fields="columns" aria-hidden="loading | listReload ? 'true' : null" :emptyText="$t('globalTrans.noDataFound')" show-empty>
                    <template v-slot:cell(index)="data">
                      {{ $n(data.index + pagination.slOffset) }}
                    </template>
                    <template v-slot:cell(application_id)="data">
                      {{ $n(data.item.application_id, { useGrouping: false }) }}
                    </template>
                    <template v-slot:cell(receipt_no)="data">
                      {{ $n(data.item.receipt_no, { useGrouping: false }) }}
                    </template>
                    <template v-slot:cell(total_devices)="data">
                      {{ $n(data.item.total_devices) }}
                    </template>
                    <template v-slot:cell(total_distributed_quantity)="data">
                      {{ $n(data.item.total_distributed_quantity) }}
                    </template>
                    <template v-slot:cell(distributed_date)="data">
                      {{ data.item.distributed_date | dateFormat }}
                    </template>
                    <template v-slot:cell(attachment)="data">
                      <a target = '_blank' v-if="data.item.d_receipt_attachment" :href="awarenessEventServiceBaseUrl + 'storage/ADDADM/receipt/' + data.item.d_receipt_attachment" download>{{$t('globalTrans.download')}}</a>
                      <b-button v-else :class="'btn btn-info text-light'"  v-b-modal.modal-4  size="sm" @click="view(data.item)"><i class="ri-ball-pen-fill m-0"></i>  {{$t('globalTrans.upload')}} </b-button>
                    </template>
                    <template v-slot:cell(action)="data">
                      <b-button v-b-modal.modal-5 variant=" iq-bg-success mr-1 mb-1" size="sm" :title="$t('globalTrans.details')" @click="view(data.item)"><i class="ri-eye-fill m-0"></i></b-button>
                    </template>
                  </b-table>
                  <b-pagination
                    v-model="pagination.currentPage"
                    :per-page="pagination.perPage"
                    :total-rows="pagination.totalRows"
                    @input="searchData"
                    />
                </b-col>
              </b-row>
            </b-overlay>
          </template>
        </iq-card>
      </b-col>
    </b-row>
    <!-- <pre>{{items}}</pre> -->
    <b-modal id="modal-5" :title="$t('delivery_management.distribution_receipt') + ' ' + $t('globalTrans.details')" size="lg" :ok-title="$t('globalTrans.close')" ok-only ok-variant="danger">
      <template #modal-title class="flex-grow-1">
        <b-button variant="primary" @click="pdfExport" class="mr-2 float-right">
          {{  $t('globalTrans.export_pdf') }}
        </b-button>
      </template>
      <p>
        <ReceiptView :id="editItemId" :key="editItemId" :item="item" ref="receipt"/>
      </p>
    </b-modal>
    <b-modal id="modal-4" size="lg" :title="$t('globalTrans.attachment')" :ok-title="$t('globalTrans.close')" ok-only ok-variant="danger">
      <Attachment :id="editItemId" :key="editItemId" :item="item"/>
    </b-modal>
  </b-container>
</template>
<script>
import ReceiptView from './DetailsModal'
import Attachment from './Attachment'
import RestApi, { awarenessEventServiceBaseUrl } from '@/config/api_config'
import { distributionReceiptList } from '../../api/routes'
import ModalBaseMasterList from '@/mixins/modal-base-master-list'
import custom from '@/store/custom'
import flatpickr from 'flatpickr'

export default {
    mixins: [ModalBaseMasterList],
    components: {
        ReceiptView, Attachment
    },
    data () {
        return {
          awarenessEventServiceBaseUrl: awarenessEventServiceBaseUrl,
          items: [],
          item: [],
          search: {
            application_id: '',
            receipt_no: '',
            from_date: '',
            to_date: ''
          },
          yearList: [],
          isRetailer: false,
          ItemShow: false,
          districtList: []
        }
    },
    created () {
        if (this.$store.state.dataFilters.officeId) {
          const centerOfficeId = this.$store.state.dataFilters.officeId
          this.activeCenter = this.idscCenterList.find(item => item.office_id === parseInt(centerOfficeId))
          this.search = Object.assign({}, this.search, {
              idsc_center_id: this.activeCenter.value,
              division_id: this.activeCenter.division_id,
              district_id: this.activeCenter.district_id
          })
        }
        this.loadData()
    },
    mounted () {
        flatpickr('.date-picker', {})
        this.search = Object.assign({}, this.search, {
            fiscal_year_id: this.$store.state.currentFiscalYearId
        })
    },
    watch: {
        'search.fiscal_year_id': function (newVal, oldVal) {
            if (newVal !== oldVal) {
            if (newVal !== 0) {
                this.fiscalYearDateRange(newVal)
            } else {
                this.search.fis_start_date = ''
                this.search.fis_end_date = ''
            }
            }
        },
        'search.division_id': function (newVal, oldVal) {
            this.districtList = this.getDistrictList(newVal)
        },
        'search.district_id': function (newVal, oldVal) {
        this.cityCorporationList = this.getCityCorporationList(newVal)
        this.upazilaList = this.getUpazilaList(newVal)
        },
        'search.upazila_id': function (newVal, oldVal) {
        this.unionList = this.getUnionList(newVal)
        this.pauroshobaList = this.getPauroshobaList(newVal)
        }
    },
    computed: {
        idscCenterList: function () {
          return this.$store.state.AwarenessEventService.commonObj.idscCenterList.filter(item => item.status === 1 && item.org_id === 3 && item.sales_center_type === 1)
        },
        i18 () {
            return (this.$i18n.locale === 'bn') ? 1 : 0
        },
        applicationTypeList: function () {
            const objectData = this.$store.state.AwarenessEventService.commonObj.assitiveDeviceApplicationTypeList
            return objectData.map((obj, key) => {
                if (this.$i18n.locale === 'bn') {
                    return { value: obj.value, text: obj.text_bn }
                } else {
                    return { value: obj.value, text: obj.text_en }
                }
            })
        },
        monthList: function () {
            return this.$store.state.commonObj.monthList
        },
        fiscalYearList: function () {
            return this.$store.state.commonObj.fiscalYearList.filter(item => item.status === 0)
        },
        registrationTypeList: function () {
            return this.$store.state.ProductionService.commonObj.registrationTypeList
        },
        currentLocale () {
            return this.$i18n.locale
        },
        // disabilityTypeList () {
        //     return this.$store.state.AwarenessEventService.commonObj.disabilityTypeList
        // },
        patientList () {
            return this.$store.state.AwarenessEventService.commonObj.patientList
        },
        getAreaTypeList: function () {
            const objectData = custom.wardTypeList
            return objectData.map((obj, key) => {
                if (this.$i18n.locale === 'bn') {
                return { value: obj.id, text: obj.name_bn }
                } else {
                return { value: obj.id, text: obj.name }
                }
            })
        },
        divisionList: function () {
            return this.$store.state.commonObj.divisionList.filter(item => item.status === 0)
        },
        columns () {
            const labels = [
                { label: this.$t('globalTrans.sl_no'), class: 'text-left' },
                { label: this.$t('globalTrans.application_id'), class: 'text-left' },
                { label: this.$t('delivery_management.receipt_no'), class: 'text-left' },
                { label: this.$t('delivery_management.distributed_date'), class: 'text-left' },
                { label: this.$t('delivery_management.total_devices'), class: 'text-right' },
                { label: this.$t('delivery_management.total_distributed_quantity'), class: 'text-right' },
                { label: this.$t('globalTrans.attachment'), class: 'text-center' },
                { label: this.$t('globalTrans.status'), class: 'text-center' }
            ]

            let keys = []

            if (this.$i18n.locale === 'bn') {
                keys = [
                    { key: 'index' },
                    { key: 'application_id' },
                    { key: 'receipt_no' },
                    { key: 'distributed_date' },
                    { key: 'total_devices' },
                    { key: 'total_distributed_quantity' },
                    { key: 'attachment' },
                    { key: 'action' }
                ]
            } else {
                keys = [
                    { key: 'index' },
                    { key: 'application_id' },
                    { key: 'receipt_no' },
                    { key: 'distributed_date' },
                    { key: 'total_devices' },
                    { key: 'total_distributed_quantity' },
                    { key: 'attachment' },
                    { key: 'action' }
                ]
            }

            return labels.map((item, index) => {
                return Object.assign(item, keys[index])
            })
      }
    },
    methods: {
        view (item) {
            this.editItemId = item.id
            this.item = item
        },
        loadData () {
          this.item = []
            this.$store.dispatch('mutateCommonProperties', { loading: true })
            const params = Object.assign({}, this.search, { page: this.pagination.currentPage, per_page: this.pagination.perPage })
            RestApi.getData(awarenessEventServiceBaseUrl, distributionReceiptList, params).then(response => {
                if (response.success) {
                    this.items = this.getRelationalData(response.data.data)
                    this.$store.dispatch('setList', this.getRelationalData(response.data.data))
                    this.paginationData(response.data)
                }
                this.$store.dispatch('mutateCommonProperties', { loading: false, listReload: false })
            })
        },
        getRelationalData (data) {
            let applicationType = {}
            let centerList = {}
            let patientList = {}
            const listData = data.map(item => {
                applicationType = this.$store.state.AwarenessEventService.commonObj.assitiveDeviceApplicationTypeList.find(application => application.value === item.application?.application_type)
                centerList = this.$store.state.AwarenessEventService.commonObj.idscCenterList.find(center => center.value === item.application.center_id)
                patientList = this.$store.state.AwarenessEventService.commonObj.patientList.find(patient => patient.value === item.application.patient_id)
                const list = {
                    application_type_en: applicationType !== undefined ? applicationType.text_en : '',
                    application_type_bn: applicationType !== undefined ? applicationType.text_bn : '',
                    center_name_en: centerList !== undefined ? centerList.text_en : '',
                    center_name_bn: centerList !== undefined ? centerList.text_bn : ''
                }
                if (item.application.application_type === 1) {
                    item.name_en = patientList !== undefined ? patientList.text_en : ''
                    item.name_bn = patientList !== undefined ? patientList.text_bn : ''
                    item.father_name_en = patientList !== undefined ? patientList.father_name : ''
                    item.father_name_bn = patientList !== undefined ? patientList.father_name_bn : ''
                    item.mother_name_en = patientList !== undefined ? patientList.mother_name : ''
                    item.mother_name_bn = patientList !== undefined ? patientList.mother_name_bn : ''
                    item.nid = patientList !== undefined ? patientList.nid : ''
                    item.birth_date = patientList !== undefined ? patientList.birth_date : ''
                    item.photo = patientList !== undefined ? patientList.photo : ''
                }
                if (item.application.application_type === 2) {
                    item.name_en = item.application.applicant_name_en
                    item.name_bn = item.application.applicant_name_bn
                }
                if (item.application.application_type === 3) {
                    item.name_en = item.application.representative_name_en
                    item.name_bn = item.application.representative_name_bn
                }
                return Object.assign({}, item, list)
            })
            return listData
        },
        searchData () {
          this.loadData()
        },
        fiscalYearDateRange (id) {
            const Date = this.$store.state.commonObj.fiscalYearList.find(item => item.value === id)
            this.search.fis_start_date = Date.start_date
            this.search.fis_end_date = Date.end_date
        },
        getDistrictList (divisionId = null) {
            const districtList = this.$store.state.commonObj.districtList.filter(item => item.status === 0)

            if (divisionId) {
                return districtList.filter(district => district.division_id === divisionId)
            }

            return districtList
        },
        pdfExport () {
          this.$refs.receipt.pdfExport()
        }
    }
  }
</script>

<style scoped>
  .width-fixed {
    width: 25%
  }
</style>
